import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionStorage, SessionStorageService } from "ngx-webstorage";
import { ProveedoresSiniestralidad, DetalleProveedoresSiniestralidad } from '../../entities/vam_entities';


@Component({
    selector: 'DetalleProveedores',
    templateUrl: 'proveedores.template.html'
})

export class ProveedoresComponent implements OnChanges, OnInit {
    public lineChartLabels: Array<any>;
    public reembolsoDiagChartData: Array<any>;
    public numReclamosDiagChartData: Array<any>;
    public lineChartLabelsReembolso: Array<any>;
    public mayorReembolsoDiagChartData: Array<any>;
    public mayorNumReclamosDiagChartData: Array<any>;
    public mayorReembolsoXValorDiagChartData: Array<any>;
    public mayorNumReclamosXValorDiagChartData: Array<any>;

    public lineChartOptions: any = {
        responsive: false,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    id: 'yAxis1',
                    position: 'left'
                },
                {
                    id: 'yAxis2',
                    position: 'right'
                }
            ]
        }
    };
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';
    public lineChartColors: Array<any> = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // dark grey
            backgroundColor: 'rgba(77,83,96,0.2)',
            borderColor: 'rgba(77,83,96,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
    ];

    ListadoProveedoresXReclamo: ProveedoresSiniestralidad;
    ListadoProveedoresXValor: ProveedoresSiniestralidad;
    @Input('siniestralidadProveedoresXReclamo')
    siniestralidadProveedoresXReclamo: ProveedoresSiniestralidad;
    @Input("siniestralidadProveedoresXValor")
    siniestralidadProveedoresXValor: ProveedoresSiniestralidad;
    @Input("Top")
    top: number = 5;
    constructor() {
        this.siniestralidadProveedoresXReclamo = new ProveedoresSiniestralidad();
        this.siniestralidadProveedoresXValor = new ProveedoresSiniestralidad();
        this.ListadoProveedoresXReclamo = new ProveedoresSiniestralidad();
        this.ListadoProveedoresXValor = new ProveedoresSiniestralidad();

        this.lineChartLabels = new Array<any>();
    }
    ngOnInit(): void {
        this.siniestralidadProveedoresXReclamo = new ProveedoresSiniestralidad();
        this.siniestralidadProveedoresXValor = new ProveedoresSiniestralidad();
        this.ListadoProveedoresXReclamo = new ProveedoresSiniestralidad();
        this.ListadoProveedoresXValor = new ProveedoresSiniestralidad();

        this.lineChartLabels = new Array<any>();
    }
    ngOnChanges(): void {
        this.ListadoProveedoresXReclamo = this.siniestralidadProveedoresXReclamo;
        this.ListadoProveedoresXValor = this.siniestralidadProveedoresXValor;
        let topSinistros: Array<any>;
        topSinistros = new Array<any>();
        if (this.ListadoProveedoresXReclamo.DetallesProveedores != null && this.ListadoProveedoresXReclamo.DetallesProveedores != undefined) {
            for (let i = 1; i <= this.ListadoProveedoresXReclamo.DetallesProveedores.length; i++) {
                topSinistros.push(i);
            }
            this.lineChartLabels = topSinistros;
            let reembolso: Array<any> = this.ListadoProveedoresXReclamo.DetallesProveedores.map(data => data.ValorReembolsado);
            let siniestros: Array<any> = this.ListadoProveedoresXReclamo.DetallesProveedores.map(data => data.NumeroReclamos);
            this.mayorReembolsoDiagChartData = [{ data: reembolso, label: 'Valor Reembolsado', yAxisID:"yAxis1" }, { data: siniestros, label: 'Número de Reclamos', yAxisID:"yAxis2" }];
            //this.mayorNumReclamosDiagChartData = [{ data: siniestros, label: 'Número de Reclamos' }];

            let reembolsoValor: Array<any> = this.ListadoProveedoresXValor.DetallesProveedores.map(data => data.ValorReembolsado);
            let siniestrosValor: Array<any> = this.ListadoProveedoresXValor.DetallesProveedores.map(data => data.NumeroReclamos);
            this.mayorReembolsoXValorDiagChartData = [{ data: reembolsoValor, label: 'Valor Reembolsado', yAxisID:"yAxis1" }, { data: siniestrosValor, label: 'Número de Reclamos', yAxisID:"yAxis2" }];
            //this.mayorNumReclamosXValorDiagChartData = [{ data: siniestrosValor, label: 'Número de Reclamos' }];
        }
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/siniestralidad/proveedores.component.ts